export default (theme) => ({
  root: {
    width: '100%',
    maxWidth: 1360,
    margin: '0px auto 30px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      margin: '15px auto 20px',
    },
  },
  providerRootQuestionnaire: {
    width: '100%',
    height: '100%',
    maxWidth: 600,
    margin: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
  progressMenu: {
    position: 'sticky',
    top: 56,
    zIndex: 999,
  },
  providerProgressMenu: {
    position: 'sticky',
    top: 0,
    zIndex: 999,
  },
  providerQuestionnaireProviderWrapper: {
    height: 'calc(100% - 30px)',
    display: 'flex',
    flexDirection: 'column',
  },
  question: {
    flexGrow: 1,
    marginRight: 15,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  },
  providerQuestion: {
    height: 'calc(100% - 20px)',
    overflow: 'hidden',
  },
});
